import { COMMON_CONSTS } from '../common/common.consts'

export const CONFIG_CONSTS = {
  moduleName: 'epb-config',

  getters: {
    instances: 'instances',
    currentInstance: 'currentInstance',
    searchKpis: 'searchKpis',
    browseKpis: 'browseKpis',
  },
  actions: {
    ...COMMON_CONSTS.actions,
    loadInstances: 'loadInstances',
  },
  mutations: {
    ...COMMON_CONSTS.mutations,
    setInstances: 'setInstances',
  },
}
